import * as React from 'react';
const leftArrow = require('../../resource/img/arrow-l.svg');
const rightArrow = require('../../resource/img/arrow-r.svg');

interface RecordsDayLeftViewProps {
    dayLeft: number,
    status: string,
    arrowDirection: 'LEFT' | 'RIGHT'
}

class RecordsDayLeftView extends React.Component<RecordsDayLeftViewProps, {}> {
    public render() {
        return (
            <div className="recordsDayLeftView">
                <img src={this.props.arrowDirection === 'LEFT' ? leftArrow : rightArrow}/>
                <div>
                    <div className="recordsDayLeftViewDayleft">{this.props.dayLeft.toString() + ' Days Left'}</div>
                    <div>{this.props.status}</div>
                </div>
            </div>
        );
    }
}

export default RecordsDayLeftView;


// WEBPACK FOOTER //
// ./src/Components/Records/RecordsDayLeftView.tsx